// extracted by mini-css-extract-plugin
export default {"block-header":"block-header__block-header___Q_sJI","blockHeader":"block-header__block-header___Q_sJI"};